import myCharacter from '../assets/my-character.jpg';
import sendImailIcon from  '../assets/send_email_icon.svg';
import {useVersionContext} from "../context/GlobalContext";
import {useEffect, useState} from "react";
import {showHideBodyContainer} from "../util/util";
import SendEmailForm from "./SendEmailForm";
import SendEmailForm2 from "./SendEmailForm2";


const Header = () => {
    const {getVersion} = useVersionContext();

    // use only for version2
    const [isOpenEmailModal, setIsOpenEmailModal] = useState(false);
    useEffect(() => {
        showHideBodyContainer(isOpenEmailModal, getVersion());
    }, [isOpenEmailModal]);

    // api 연동 대비해서 json key-value 로 사용
    const contentData = {
            // headerTitle: 'Joonbok Lee',
            // headerTitle: '개발자 ( 이준복 );',
            headerTitle: "It's me, 이준복",
            blogLink: 'https://letsdodev.tistory.com/' || '',
            blogIconHref: myCharacter || '#',
            gitLink: 'https://github.com/ljbok/',
            sendImageIcon: {sendImailIcon}
        }
    if (getVersion() === 2) {
        contentData.headerTitle = "I'm a Developer 이준복";
   /*     contentData.blogTitle = "개발놀이터";
        contentData.emailTitle = "편지보내기";
        contentData.githubTitle = "깃허브구경하기";*/
        // contentData.blogTitle = "✨ 블로그";
        // contentData.emailTitle = "📧 메일";
        // contentData.githubTitle = "🌟 깃허브";
        contentData.blogTitle = "블로그";
        contentData.emailTitle = "메일";
        contentData.githubTitle = "깃허브";
    }

    return (
        <>
            {getVersion() === 1 && (
                <header className="border-bottom lh-1 py-3">
                    <div className="row flex-nowrap justify-content-between align-items-center">
                        <div className="col-1 pt-1">
                            {/*<a className="link-secondary" href="#"></a>*/}
                        </div>
                        <div className="col-10 text-center">
                            <a className="blog-header-logo text-body-emphasis text-decoration-none" href="#">
                                <div className='custom-header-title fs-1'>{contentData?.headerTitle || ''}</div>
                            </a>
                        </div>
                        <div className="col-1 d-flex justify-content-end align-items-center">
                        </div>
                    </div>
                </header>
            )}
            {getVersion() === 2 && (
                <>
                    <header className="header-margin">
                        <div className="d-flex flex-column flex-md-row align-items-center pb-3 mb-4 border-bottom">
                            {/*<a href="/" className="d-flex align-items-center link-body-emphasis text-decoration-none">*/}
                            {/*    <img className='header-icon'*/}
                            {/*         src={myCharacter}*/}
                            {/*         width="50" height="32"*/}
                            {/*         alt="logo"/>*/}
                            {/*    <span className="fs-4">*/}
                            {/*        {contentData.headerTitle}*/}
                            {/*    </span>*/}
                            {/*</a>*/}
                            <nav className="d-inline-flex mt-2 mt-md-0 ms-md-auto">
                                <a
                                    className="custom-header-link me-3 py-2 link-body-emphasis text-decoration-none" href={contentData.blogLink}
                                    target="_blank" rel="noreferrer">
                                    {contentData.blogTitle}
                                </a>
                                <a
                                    className="custom-header-link me-3 py-2 link-body-emphasis text-decoration-none" href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setIsOpenEmailModal(true);
                                    }}
                                    target="_blank">
                                    {contentData.emailTitle}
                                </a>
                                <a
                                    className="custom-header-link me-3 py-2 link-body-emphasis text-decoration-none" href={contentData.gitLink}
                                    target="_blank" rel="noreferrer">
                                    {contentData.githubTitle}
                                </a>
                            </nav>
                        </div>
                    </header>
                    {isOpenEmailModal && getVersion() === 1 && (
                        <SendEmailForm setIsOpenEmailModal={setIsOpenEmailModal}/>
                    )}
                    {isOpenEmailModal && getVersion() === 2 && (
                        <SendEmailForm2 setIsOpenEmailModal={setIsOpenEmailModal}/>
                    )}
                </>
            )}
        </>);
}

export default Header;

